import { render, staticRenderFns } from "./FlashNewsListView.vue?vue&type=template&id=c8dc86ea&scoped=true&"
import script from "./FlashNewsListView.vue?vue&type=script&lang=ts&"
export * from "./FlashNewsListView.vue?vue&type=script&lang=ts&"
import style0 from "./FlashNewsListView.vue?vue&type=style&index=0&id=c8dc86ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8dc86ea",
  null
  
)

export default component.exports